/**
 * TODO: _sample app module
 */
export const ENTITY_NAME = 'Progression Scorecard';
export const PAGE_TITLES = {
    create: `Create an entity type`,
    view: `View entity type`,
    list: `Manage entity type`,
};
export const reduxActionTypePrefix = `progression-scorecard`;
export const TriggeredScorecardDefaults = {
    FeatureGateExpression: `"{FeatureGateName}"`,
};
export var SupportedTriggerType;
(function (SupportedTriggerType) {
    SupportedTriggerType["feature_gate"] = "feature_gate";
    SupportedTriggerType["auto_generate"] = "auto_generate";
    SupportedTriggerType["manual"] = "manual";
    SupportedTriggerType["no_trigger"] = "no_trigger";
    SupportedTriggerType["side_stream_manual"] = "side_stream_manual";
    SupportedTriggerType["custom"] = "custom";
})(SupportedTriggerType || (SupportedTriggerType = {}));
export const AUTOMATIC_GROUP_HEADER = 'Automatic analysis';

//# sourceMappingURL=module.constants.js.map
